export const HELP_URL = 'https://help.estrack.com/en/collections/19626030-integrations'
export const WHATS_NEW_URL = 'https://updates.equipmentshare.com/tag/integrations'
